import { useQuery } from '@tanstack/react-query';

import { withError } from '@/react-tools/react-query';

import { DetailLogsGetFn } from './types';

export const PAGE_SIZE = 100;

export function useDetailLogsQuery({
  queryKey,
  getLogsFn,
  page,
  severities,
  since,
  until,
  search,
}: {
  queryKey: readonly unknown[];
  getLogsFn: DetailLogsGetFn;
  page: number;
  severities: string[];
  since: number;
  until: number;
  search: string;
}) {
  return useQuery(
    [...queryKey, page, severities, since, until, search],
    () =>
      getLogsFn({
        since,
        until,
        limit: PAGE_SIZE,
        skip: page * PAGE_SIZE,
        severities,
        search,
      }),
    {
      // Keep the previous page's rows on screen while the next page or a new
      // filter loads, so paging doesn't flash the full loading state.
      keepPreviousData: true,
      // A rejected range/filter combination fails the same way every time,
      // so the default 3 retries just delay the error by several seconds.
      retry: 1,
      ...withError('Unable to load logs'),
    }
  );
}
